// Engine API: agent audit events.
// Backed by ~/Dev/seitiate/app/api/v1/agent_audit_events.py (shipped in
// seitiate#35, merged 2026-05-04).

import { engineFetchJson } from '@/lib/engineHttp';
import type {
  AgentAuditEventListResponse,
  PolicyDecisionKind,
} from './agentBoardTypes';

export interface ListAgentAuditEventsParams {
  owner_id?: string;
  agent_identity_id?: string;
  agent_run_id?: string;
  delegation_id?: string;
  action_type?: string;
  policy_decision?: PolicyDecisionKind;
  /** ISO 8601 timestamp; lower bound on created_at (inclusive). */
  since?: string;
  /** ISO 8601 timestamp; upper bound on created_at (exclusive). */
  before?: string;
  /** Page size; engine caps at 500, default 100. */
  limit?: number;
}

/** GET /api/v1/agent-audit-events with optional filters. */
export async function listAgentAuditEvents(
  params: ListAgentAuditEventsParams = {},
): Promise<AgentAuditEventListResponse> {
  const qs = new URLSearchParams();
  if (params.owner_id) qs.set('owner_id', params.owner_id);
  if (params.agent_identity_id) qs.set('agent_identity_id', params.agent_identity_id);
  if (params.agent_run_id) qs.set('agent_run_id', params.agent_run_id);
  if (params.delegation_id) qs.set('delegation_id', params.delegation_id);
  if (params.action_type) qs.set('action_type', params.action_type);
  if (params.policy_decision) qs.set('policy_decision', params.policy_decision);
  if (params.since) qs.set('since', params.since);
  if (params.before) qs.set('before', params.before);
  if (typeof params.limit === 'number') qs.set('limit', String(params.limit));

  const suffix = qs.toString();
  return engineFetchJson<AgentAuditEventListResponse>(
    `/agent-audit-events${suffix ? `?${suffix}` : ''}`,
  );
}
